import { createStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string> => createStyles({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
  content: {
    minWidth: theme.spacing(48),
  },
  title: {
    color: theme.palette.common.white,
    background: theme.palette.primary.main,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  footer: {
    background: theme.palette.background.default,
  },
});

export default styles;
